import classNames from 'classnames';
import { IoMdClose } from 'react-icons/io';
import { Link } from 'react-router-dom';

import Button from '../../../components/Button';
import { EbookStatus, PintoEbookSubmissionItemStatus } from '../../../core/graphql/types';
import { getDayTime } from '../../../utils/dayjs';
import { EBOOK_SUBMISSION_ITEM_STATUS_CLASS_NAME, EBOOK_SUBMISSION_ITEM_STATUS_LABEL } from '../constants/status';

const DATE_FORMAT = 'DD-MM-YYYY hh:mm A';

export interface IPropsEbookSubmissionItemRow {
  _id: string;
  status: PintoEbookSubmissionItemStatus;
  data?: { title?: string };
  errorNote?: string | null;
  ebookId?: string | null;
  ebook?: { status: EbookStatus; publishedAt?: string | null } | null;
  onCancel: (itemId: string) => void;
}

function EbookSubmissionItemRow(props: IPropsEbookSubmissionItemRow) {
  const { _id, status, data, errorNote, ebookId, ebook, onCancel } = props;

  const title = data?.title || 'Untitled item';
  const canCancel = status === PintoEbookSubmissionItemStatus.Pending;

  return (
    <tr className="hover font-tt">
      <th className="font-normal">
        {ebookId ? (
          <Link to={`/ebooks/detail?id=${ebookId}`} className="underline text-colorsBrandRed01Primary">
            {title}
          </Link>
        ) : (
          title
        )}
      </th>
      <td>
        <div className={classNames(EBOOK_SUBMISSION_ITEM_STATUS_CLASS_NAME[status])}>{EBOOK_SUBMISSION_ITEM_STATUS_LABEL[status]}</div>
      </td>
      <td>{ebook ? <div className="badge capitalize">{ebook.status}</div> : '-'}</td>
      <td>{ebook?.publishedAt ? getDayTime(ebook.publishedAt, DATE_FORMAT) : '-'}</td>
      <td>{errorNote ? <span className="text-colorsBrandRed01Primary text-14">{errorNote}</span> : '-'}</td>
      <td>
        {canCancel && (
          <Button type="ghost" color="red" className="space-x-4 text-colorsBrandRed01Primary" onClick={() => onCancel(_id)}>
            <IoMdClose />
            <span>Cancel</span>
          </Button>
        )}
      </td>
    </tr>
  );
}

export default EbookSubmissionItemRow;
